const Error= ()=>{
    return(
        <div className="error-message">
            Error: No results! Please try again.
        </div>
    );
};
export default Error;